
export const MESSAGE_SEND = 'MESSAGE_SEND';
export const MESSAGE_SEND_USER = 'MESSAGE_SEND_USER';
export const MESSAGE_SEND_CLASS = 'MESSAGE_SEND_CLASS';
export const MESSAGE_GET_ALL = 'MESSAGE_GET_ALL';
export const MESSAGE_DETAILS = 'MESSAGE_DETAILS';
export const MESSAGE_GET_USER = 'MESSAGE_GET_USER';
export const MESSAGE_READ = 'MESSAGE_READ'